import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';

  get spinnerClasses(): string[] {
    const classes: string[] = ['animate-spin', 'rounded-full', 'border-solid', 'border-t-transparent'];

    switch (this.size) {
      case 'small':
        classes.push('h-6', 'w-6', 'border-2');
        break;
      case 'large':
        classes.push('h-12', 'w-12', 'border-4');
        break;
      case 'medium':
      default:
        classes.push('h-8', 'w-8', 'border-3'); // Default medium size
        break;
    }

    switch (this.color) {
      case 'accent':
        classes.push('border-sky-600'); // Primary Blue from style guide
        break;
      case 'warn':
        classes.push('border-red-600'); // Primary Red from style guide
        break;
      case 'primary':
      default:
        classes.push('border-sky-600'); // Default to Primary Blue
        break;
    }

    return classes;
  }
}